import type { Eip6963AnnounceProviderEvent } from '../../eip6963.types';

export const isEip6963Event = (
  event: unknown
): event is Eip6963AnnounceProviderEvent =>
  event !== null &&
  event !== undefined &&
  (event as Eip6963AnnounceProviderEvent).type === 'eip6963:announceProvider' &&
  (event as Eip6963AnnounceProviderEvent).detail !== undefined &&
  (event as Eip6963AnnounceProviderEvent).detail !== null;
